[
  {
    "id": 4719,
    "uuid": "367e7357-d783-4190-8893-ba614fbdc34e",
    "hitokoto": "爱你所爱，行你所行，听从你心，无问西东。",
    "type": "h",
    "from": "无问西东",
    "from_who": null,
    "creator": "jhaseh",
    "creator_uid": 4818,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580886541",
    "length": 20
  },
  {
    "id": 4723,
    "uuid": "b77b6dec-d3eb-4ebd-9b6c-2109fcdd37f6",
    "hitokoto": "高调做事，低调做人。",
    "type": "h",
    "from": "某电视剧",
    "from_who": null,
    "creator": "陈未来",
    "creator_uid": 1803,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580792293",
    "length": 10
  },
  {
    "id": 4857,
    "uuid": "b7022b7c-8ebb-4900-b405-aba3372c00cd",
    "hitokoto": "我感谢一切我有权奉承的神明，让我在这个不唯一的世界遇见唯一的你。",
    "type": "h",
    "from": "Vitamin少女",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580370816",
    "length": 32
  },
  {
    "id": 4897,
    "uuid": "b968d447-4f1d-48e5-99f2-ae0c12c51b88",
    "hitokoto": "最是人间留不住，朱颜辞镜花辞树。",
    "type": "h",
    "from": "蝶恋花·阅尽天涯离别苦",
    "from_who": "王国维",
    "creator": "鳯凰栖梧",
    "creator_uid": 4071,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1571142742",
    "length": 16
  },
  {
    "id": 4904,
    "uuid": "2cc456b1-259e-47c0-83b4-4eba76a28d52",
    "hitokoto": "虽然我和他已十年不见，但我知道我会永远怀念他。",
    "type": "h",
    "from": "伴我同行",
    "from_who": "伴我同行",
    "creator": "wu qingfeng",
    "creator_uid": 2225,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1574250827",
    "length": 23
  },
  {
    "id": 4906,
    "uuid": "adc8e369-fae2-4433-8b2b-06bebcb3efd1",
    "hitokoto": "成年人的世界没有容易二字。",
    "type": "h",
    "from": "天气预报员",
    "from_who": "天气预报员",
    "creator": "草鱼禾",
    "creator_uid": 3669,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1573714325",
    "length": 13
  },
  {
    "id": 5000,
    "uuid": "e483b2b5-3a45-482c-ab04-936192ee7d3f",
    "hitokoto": "最初，没有人在意这场灾难，这不过是一场山火，一次旱灾，一个物种的灭绝，一座城市的消失。直到这场灾难和每个人息息相关。",
    "type": "h",
    "from": "流浪地球",
    "from_who": "刘慈欣",
    "creator": "Husky",
    "creator_uid": 4861,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581398835",
    "length": 58
  },
  {
    "id": 5061,
    "uuid": "8277f7ea-e3a8-4e35-8607-9a2797f0ab2e",
    "hitokoto": "An apple once a day，keep your enemies away.",
    "type": "h",
    "from": "白雪公主",
    "from_who": "皇后",
    "creator": "长庚",
    "creator_uid": 4728,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1580116451",
    "length": 43
  },
  {
    "id": 5076,
    "uuid": "2ed7c635-b513-4f11-8aa2-18ec6d66c674",
    "hitokoto": "I will see you in another life, when we are both cats.",
    "type": "h",
    "from": "Vanilla Sky",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1582074043",
    "length": 54
  },
  {
    "id": 5090,
    "uuid": "6855227a-b5f4-417a-acb1-c26cac2bf9d0",
    "hitokoto": "那就是在梦里，找一个很高很高的地方，然后往下跳，不管再恐怖的噩梦都会结束。",
    "type": "h",
    "from": "想加你",
    "from_who": "陈韵如",
    "creator": "scvoet",
    "creator_uid": 1713,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1582459011",
    "length": 37
  },
  {
    "id": 5111,
    "uuid": "5846beb5-0401-477f-b091-33a80283570f",
    "hitokoto": "迎着风，拥抱彩虹！",
    "type": "h",
    "from": "你的答案",
    "from_who": "黄霄雲",
    "creator": "辣椒の酱",
    "creator_uid": 4270,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1582694688",
    "length": 9
  },
  {
    "id": 5122,
    "uuid": "99f4794d-ee82-497f-aa95-e58963ef9474",
    "hitokoto": "Everything ends. But everything begins again too.",
    "type": "h",
    "from": "奇异博士",
    "from_who": null,
    "creator": "serenityooooo_SS",
    "creator_uid": 4656,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1579018067",
    "length": 49
  },
  {
    "id": 5147,
    "uuid": "2e6c98a8-5d67-4e1d-ad02-a8f4feb8a5b3",
    "hitokoto": "虽有遗憾，绝不后悔。",
    "type": "h",
    "from": "古剑奇谭",
    "from_who": null,
    "creator": "焦糖玛奇朵",
    "creator_uid": 4516,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1576919441",
    "length": 10
  },
  {
    "id": 5166,
    "uuid": "61914e8d-9ae2-46b9-bc84-db85e4ac1781",
    "hitokoto": "明明想做个好人，最后却变成了坏人，以为能做个超人，才发现甚至当不好一个凡人，在名为人生的这个大公司里，命运才是我们的顶头上司，虽然人生不能换，命运不能选，幸好还有这群好同事，好兄弟，一起互相伤害。",
    "type": "h",
    "from": "人生无限公司",
    "from_who": "五月天",
    "creator": "MayDay",
    "creator_uid": 5129,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1582876573",
    "length": 98
  },
  {
    "id": 5183,
    "uuid": "b72527f8-010c-49a8-a0b3-d91307113cd7",
    "hitokoto": "Why so serious?",
    "type": "h",
    "from": "小丑",
    "from_who": "小丑",
    "creator": "你会梦游，我会磨牙",
    "creator_uid": 5085,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1583075832",
    "length": 15
  },
  {
    "id": 5234,
    "uuid": "f560733d-1cd0-4b21-8147-18c4916b596e",
    "hitokoto": "你说过，人最大的敌人是自己。",
    "type": "h",
    "from": "我的前半生",
    "from_who": "贺涵",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1583786533",
    "length": 14
  },
  {
    "id": 5264,
    "uuid": "971cc80e-d0ee-42de-8549-c3ed938e3d2a",
    "hitokoto": "A lion does not concern himself with the opinion of sheep.",
    "type": "h",
    "from": "权力的游戏",
    "from_who": null,
    "creator": "未见天地辽阔时",
    "creator_uid": 5341,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1583893749",
    "length": 58
  },
  {
    "id": 5265,
    "uuid": "a272c0f3-7508-4f5b-b6dc-2c2dbd9b4293",
    "hitokoto": "There's a beast in every man, and it stirs when you put a sword in his hand.",
    "type": "h",
    "from": "权力的游戏",
    "from_who": null,
    "creator": "未见天地辽阔时",
    "creator_uid": 5341,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1583893817",
    "length": 76
  },
  {
    "id": 5266,
    "uuid": "c588749f-47ac-4d1e-bfb9-4b4fba6a88ee",
    "hitokoto": "Valar morghulis; Valar dohaeris.",
    "type": "h",
    "from": "权力的游戏",
    "from_who": null,
    "creator": "未见天地辽阔时",
    "creator_uid": 5341,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1583894042",
    "length": 32
  },
  {
    "id": 5269,
    "uuid": "f8de114f-b98a-4872-ac7b-44b42c47f02c",
    "hitokoto": "不是每一个人都能成为伟大的艺术家，但是伟大的艺术家可以来自任何一个地方。",
    "type": "h",
    "from": "料理鼠王",
    "from_who": "小米",
    "creator": "Furley",
    "creator_uid": 4386,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1584030182",
    "length": 36
  },
  {
    "id": 5308,
    "uuid": "4cf04022-267b-4837-b649-f2938d33a38d",
    "hitokoto": "陆上的人喜欢寻根问底，虚度了大好光阴，冬天忧虑夏天的姗姗来迟，夏天忧虑冬天的将至，所以他们不停四处游走，追求一个遥不可及的四季如夏的地方，然而我并不羡慕。",
    "type": "h",
    "from": "海上钢琴师",
    "from_who": "1900",
    "creator": "西门吹水",
    "creator_uid": 5544,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1584697156",
    "length": 77
  },
  {
    "id": 5343,
    "uuid": "08d173d0-62a2-45e5-bece-b013ed33f721",
    "hitokoto": "我们生活在阴沟里，但有人依然仰望星空。",
    "type": "h",
    "from": "少年的你",
    "from_who": "陈念",
    "creator": "石皮虫圭",
    "creator_uid": 5645,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1585269003",
    "length": 19
  },
  {
    "id": 5347,
    "uuid": "87531a99-fb7b-420d-8af3-4067139050f5",
    "hitokoto": "所以我松开拳头用手握紧笔，作为自己作为人类也作为你。",
    "type": "h",
    "from": "贰拾",
    "from_who": "张颜齐",
    "creator": "Muzi.言寺",
    "creator_uid": 5655,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585291368",
    "length": 26
  },
  {
    "id": 5350,
    "uuid": "10d716e8-79b5-4a2e-93e9-1092e306684b",
    "hitokoto": "谎话被歌颂，扮清醒的人作哑装聋。",
    "type": "h",
    "from": "不痛",
    "from_who": "南语",
    "creator": "Muzi.言寺",
    "creator_uid": 5655,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585293573",
    "length": 16
  },
  {
    "id": 5354,
    "uuid": "9b55d093-7249-4250-8bda-be149f43f4b7",
    "hitokoto": "如果你有梦想，就要守护它。",
    "type": "h",
    "from": "当幸福来敲门",
    "from_who": "克里斯·加德纳",
    "creator": "橘子_ORANGE",
    "creator_uid": 5229,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585296385",
    "length": 13
  },
  {
    "id": 5355,
    "uuid": "ec21ccfe-4e48-4b1a-95c4-9b5ae0c5200d",
    "hitokoto": "当人们做不到一些事情的时候，他们会对你说你也同样不能。",
    "type": "h",
    "from": "当幸福来敲门",
    "from_who": "克里斯·加德纳",
    "creator": "橘子_ORANGE",
    "creator_uid": 5229,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585296454",
    "length": 27
  },
  {
    "id": 5357,
    "uuid": "cfb54352-6c7e-4903-9afb-1dc2b3c4be40",
    "hitokoto": "隔着人潮呼救像只困兽，呼吸颤抖去泪流，去相拥。",
    "type": "h",
    "from": "不痛",
    "from_who": "南语",
    "creator": "Muzi.言寺",
    "creator_uid": 5655,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585293619",
    "length": 23
  },
  {
    "id": 5358,
    "uuid": "d6e59b5a-6a12-4d14-ac64-fc0977de6853",
    "hitokoto": "曾盛开过一朵，曾不会败落，曾在他眼中流淌过浩瀚的银河。",
    "type": "h",
    "from": "不痛",
    "from_who": "南语",
    "creator": "Muzi.言寺",
    "creator_uid": 5655,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585293655",
    "length": 27
  },
  {
    "id": 5362,
    "uuid": "5bf9d153-8309-4db3-a59b-28572432a1e4",
    "hitokoto": "忘掉生日，忘掉青涩的诗，忘掉他不厌其烦夜夜追逐他影子。",
    "type": "h",
    "from": "菱形月亮",
    "from_who": "邱意",
    "creator": "Muzi.言寺",
    "creator_uid": 5655,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585293912",
    "length": 27
  },
  {
    "id": 5387,
    "uuid": "f1988762-9dc2-4151-9b1c-c236d2e987ab",
    "hitokoto": "金钱和女人，是人生犯错的根源。",
    "type": "h",
    "from": "贫民窟里的百万富翁",
    "from_who": "丹尼·鮑伊",
    "creator": "wait.",
    "creator_uid": 3905,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1585215070",
    "length": 15
  },
  {
    "id": 5393,
    "uuid": "60f97a7e-2fe2-4a40-88c8-664d59c7d939",
    "hitokoto": "祈愿万家灯火熨烫过脉络，刀山与火海多深刻，都陪你渡过。",
    "type": "h",
    "from": "不痛",
    "from_who": "南语",
    "creator": "Muzi.言寺",
    "creator_uid": 5655,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1585293712",
    "length": 27
  },
  {
    "id": 5425,
    "uuid": "3ebbaea4-a4d7-4600-abe4-2806ea864d69",
    "hitokoto": "we are in the gutter, but some of us are looking at the stars.",
    "type": "h",
    "from": "少年的你",
    "from_who": "陈念",
    "creator": "freejishu",
    "creator_uid": 1,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1585616988",
    "length": 62
  },
  {
    "id": 5427,
    "uuid": "e80083dc-e147-418c-a93d-4377c4ff8c2d",
    "hitokoto": "呐，做人呢，最重要的是开心，你饿不饿，我煮碗面给你吃啊。",
    "type": "h",
    "from": "大内密探零零发",
    "from_who": "周星驰",
    "creator": "hkaren",
    "creator_uid": 5713,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1585647296",
    "length": 28
  },
  {
    "id": 5851,
    "uuid": "79fdc5c2-3df9-4e8d-ac0c-1a9888ea8c06",
    "hitokoto": "Tough times don't last, tough people do.",
    "type": "h",
    "from": "Elementary",
    "from_who": "Joan Watson",
    "creator": "flowphyl",
    "creator_uid": 2150,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586362271",
    "length": 40
  },
  {
    "id": 5982,
    "uuid": "891c1225-6ba2-48c7-b2ae-f7fc6ea024c7",
    "hitokoto": "经不经典这种事，每个人本来就不一样嘛。因为，你有你的回忆，我有我的传记，只要感动，都是经典。",
    "type": "h",
    "from": "五月天人生无限公司",
    "from_who": null,
    "creator": "Little_Qiu",
    "creator_uid": 1032,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1588353078",
    "length": 46
  },
  {
    "id": 6007,
    "uuid": "3cd19674-3f70-43c8-9c84-9f8479ef73dc",
    "hitokoto": "就像是一场华尔街的阴谋，透露着优雅的杀戮。",
    "type": "h",
    "from": "神探夏洛克",
    "from_who": null,
    "creator": "Npc玩家柯拉",
    "creator_uid": 5658,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1586939443",
    "length": 21
  },
  {
    "id": 6008,
    "uuid": "b6c5a5f9-744e-4e71-83bf-28282026017f",
    "hitokoto": "一个细胞里，却分裂出了两种截然不同的命运。",
    "type": "h",
    "from": "法医秦明",
    "from_who": "秦明",
    "creator": "Npc玩家柯拉",
    "creator_uid": 5658,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1586939487",
    "length": 21
  },
  {
    "id": 6019,
    "uuid": "ba1a90e0-967c-4db5-bd48-ea2ffb4ce85c",
    "hitokoto": "人的痛苦会把自己折磨到多深呢？",
    "type": "h",
    "from": "如实陈述",
    "from_who": null,
    "creator": "Npc玩家柯拉",
    "creator_uid": 5658,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1586776496",
    "length": 15
  },
  {
    "id": 6021,
    "uuid": "297c2f75-5426-4315-b4a4-d154fe134934",
    "hitokoto": "如果你仲记得我，就返转头啦。",
    "type": "h",
    "from": "刑事侦缉档案",
    "from_who": null,
    "creator": "Npc玩家柯拉",
    "creator_uid": 5658,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1586939583",
    "length": 14
  },
  {
    "id": 6029,
    "uuid": "d155855e-0af9-4bdb-8e35-157a6a861a67",
    "hitokoto": "世界上有三种欺诈师，欺骗别人金钱的白鹫；用美色来玩弄别人心灵的红鹫；还有一种只把白鹫和红鹫当成猎物的史上最强的欺诈师。他的名字叫做黑鹫。",
    "type": "h",
    "from": "欺诈猎人",
    "from_who": null,
    "creator": "Npc玩家柯拉",
    "creator_uid": 5658,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1586939770",
    "length": 68
  },
  {
    "id": 6030,
    "uuid": "131af05a-0a73-4156-b1a7-afaf4bbcd1d9",
    "hitokoto": "那片洁白无瑕的雪地上留下的两个人的回忆很快就会消失，只有那十字，那隔窗的吻痕，那棵树，那人的心在自己胸膛留下的心跳声，永存不灭。",
    "type": "h",
    "from": "天国的树",
    "from_who": null,
    "creator": "Npc玩家柯拉",
    "creator_uid": 5658,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1586939826",
    "length": 64
  },
  {
    "id": 6104,
    "uuid": "9673fb1f-c853-4c1b-bcfd-8799e7f7d891",
    "hitokoto": "世事变幻无常，而近乎永恒不变者，唯你我头上的同一片星空。",
    "type": "h",
    "from": "万国志",
    "from_who": null,
    "creator": "PercyDan",
    "creator_uid": 6125,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1588648123",
    "length": 28
  },
  {
    "id": 6105,
    "uuid": "78f1d91c-d69e-446a-bfd3-c3b3ea5d047c",
    "hitokoto": "如果温柔是罪，那就只能用拳头来洗清我们犯下的罪孽。",
    "type": "h",
    "from": "镇魂街",
    "from_who": "曹玄亮",
    "creator": "PercyDan",
    "creator_uid": 6125,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1588658329",
    "length": 25
  },
  {
    "id": 6179,
    "uuid": "fbfe7587-9b18-4422-afb3-380e9fa86403",
    "hitokoto": "I will always be here for you.",
    "type": "h",
    "from": "环太平洋 Pacific Rim",
    "from_who": null,
    "creator": "Awoluua_",
    "creator_uid": 6258,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590074335",
    "length": 30
  },
  {
    "id": 6288,
    "uuid": "62f649c8-0b7a-4327-9d0c-e56754e7f52b",
    "hitokoto": "我花了二十多年告诉我的女儿如何保护自己，你却没有花十分钟教你的儿子不要伤害女孩子。",
    "type": "h",
    "from": "一个母亲的复仇",
    "from_who": "吉里什·科赫利",
    "creator": "朝烟",
    "creator_uid": 6473,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1592397411",
    "length": 41
  },
  {
    "id": 6297,
    "uuid": "d6e55120-3aea-439c-965d-70d957a26925",
    "hitokoto": "爸爸我也不是一生下来就是爸爸，爸爸也是头一次当爸爸。",
    "type": "h",
    "from": "请回答1988",
    "from_who": "德善父亲",
    "creator": "xuj",
    "creator_uid": 6496,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1592529632",
    "length": 26
  },
  {
    "id": 6306,
    "uuid": "6f716915-eaf4-480a-9a9b-24df42d5c1e1",
    "hitokoto": "我想虽然现在是太空时代，人类早就可以坐太空船去月球，但永远无法探索别人内心的宇宙。",
    "type": "h",
    "from": "大佛普拉斯",
    "from_who": null,
    "creator": "像风",
    "creator_uid": 6731,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1594981207",
    "length": 41
  },
  {
    "id": 6325,
    "uuid": "2017e206-f81b-48c1-93e3-53a63a9de199",
    "hitokoto": "自责要短暂，不过要长久铭记。",
    "type": "h",
    "from": "当你沉睡时",
    "from_who": null,
    "creator": "沈时筠",
    "creator_uid": 6568,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1593237879",
    "length": 14
  },
  {
    "id": 6403,
    "uuid": "8b009bba-40a2-4603-acbf-f6ac283f6524",
    "hitokoto": "You complete me !",
    "type": "h",
    "from": "黑暗骑士",
    "from_who": "joker",
    "creator": "wick",
    "creator_uid": 6853,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1596239713",
    "length": 17
  },
  {
    "id": 6408,
    "uuid": "5c3cbfef-562e-421a-b4a2-22f63615b25b",
    "hitokoto": "痛苦犹如一艘船，欲望是指南针。",
    "type": "h",
    "from": "暗黑",
    "from_who": null,
    "creator": "chilam",
    "creator_uid": 6424,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1595569612",
    "length": 15
  },
  {
    "id": 6461,
    "uuid": "c8ec8470-aafb-4b17-b149-3d4807bab03b",
    "hitokoto": "当时光的列车缓缓驶过酋长球场，32岁的亨利就坐在那里，深情的目光望过去，都是自己22岁的影子。",
    "type": "h",
    "from": "天下足球",
    "from_who": null,
    "creator": "流幻的光",
    "creator_uid": 7468,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1602838143",
    "length": 47
  },
  {
    "id": 6468,
    "uuid": "4f756fa1-59f8-4609-8a17-ca11813ed6b6",
    "hitokoto": "I'll do anything to get back what I lost.",
    "type": "h",
    "from": "The Flash",
    "from_who": "Eobard Thawne",
    "creator": "流幻的光",
    "creator_uid": 7468,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1602837828",
    "length": 41
  },
  {
    "id": 6472,
    "uuid": "96ee1e66-508d-422f-acf1-b7de9de596ae",
    "hitokoto": "I'm nothing without you.",
    "type": "h",
    "from": "The Flash",
    "from_who": "Clifford Devo",
    "creator": "流幻的光",
    "creator_uid": 7468,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1602837770",
    "length": 24
  },
  {
    "id": 6479,
    "uuid": "81bd23ed-fffc-41d9-b36b-75f4cf2e84ee",
    "hitokoto": "看看人间的苦难，听听人民的呐喊！",
    "type": "h",
    "from": "悲惨世界",
    "from_who": "《悲惨世界》音乐剧",
    "creator": "Serastan",
    "creator_uid": 7394,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1602079304",
    "length": 16
  },
  {
    "id": 6568,
    "uuid": "b55e7fde-aec1-4f66-87e1-56201aa4d384",
    "hitokoto": "Have you ever danced with devil in the pale moonligh?",
    "type": "h",
    "from": "Batman(1989)",
    "from_who": "The Joker (Jack Nicholson)",
    "creator": "wick",
    "creator_uid": 6853,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1600867959",
    "length": 53
  },
  {
    "id": 6728,
    "uuid": "79d002bd-dd40-4990-90f6-6946f0cbf0e2",
    "hitokoto": "我会把历史欠你的都给你还回来，我要让褚嬴的名字传遍大江南北，让你成为真正的棋王！",
    "type": "h",
    "from": "棋魂",
    "from_who": "时光",
    "creator": "方栩栩",
    "creator_uid": 7486,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1605408531",
    "length": 40
  },
  {
    "id": 6739,
    "uuid": "7f16df4e-57f8-49af-a140-601e3d1e9f7c",
    "hitokoto": "你现在的气质里，藏着你走过的路，读过的书和爱过的人。",
    "type": "h",
    "from": "卡萨布兰卡",
    "from_who": "迈克尔·柯蒂茲",
    "creator": "小透明",
    "creator_uid": 7788,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1605768805",
    "length": 26
  },
  {
    "id": 6771,
    "uuid": "4ee65e3d-5884-498d-931f-f4a0c4504b9c",
    "hitokoto": "めまぐるしい景色の中,君だけが止まって見えた.",
    "type": "h",
    "from": "グランドエスケープ",
    "from_who": "野田洋次郎",
    "creator": "qiokio",
    "creator_uid": 8506,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1613294162",
    "length": 23
  },
  {
    "id": 6835,
    "uuid": "54df9e33-5e17-40ad-9532-df27681657ae",
    "hitokoto": "我希望，你能见识到令你惊奇的事物；我希望，你能体验未曾体验的情感；我希望，你能遇见一些想法不同的人；我希望，你为你自己的人生感到骄傲。如果你发现自己还没做到，我希望，你有勇气，从头再来。",
    "type": "h",
    "from": "返老还童",
    "from_who": "本杰明",
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607219097",
    "length": 93
  },
  {
    "id": 6840,
    "uuid": "f64b29c1-10fd-4e07-b1dc-43763f79c7bc",
    "hitokoto": "有些人沦为平庸浅薄，玉其外，而败絮其中。可不经意间，有一天你会遇到一个彩虹般绚丽的人，从此以后，其他人就不过是匆匆浮云。",
    "type": "h",
    "from": "怦然心动",
    "from_who": null,
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607219550",
    "length": 60
  },
  {
    "id": 6843,
    "uuid": "adcdd620-1512-46dd-afc9-fcb4be72108d",
    "hitokoto": "厨房里有煮好的饭，另外我还买了几个杯子，我知道，用不了多久就都会被打破，所以我偷偷藏起了一个，到有一天你需要那个杯子的时候，就打一个电话给我，我会告诉你放在什么地方。",
    "type": "h",
    "from": "旺角卡门",
    "from_who": null,
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607219692",
    "length": 83
  },
  {
    "id": 6860,
    "uuid": "30973235-3d2b-47dd-873e-9cb5dd8171aa",
    "hitokoto": "我想有一天和你去旅行,去那没有去过的地方，没有行李,没有背包,不带电脑更不要手机,走一个地方停一个地方。在我心里最美好的就是和你一起老在路上,捕捉最后的流星,坐在最高的山顶上,听音乐,聊电影,吃东西....当日出越过山涧，我未老，你依然。",
    "type": "h",
    "from": "飞屋环游记",
    "from_who": null,
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607266120",
    "length": 119
  },
  {
    "id": 6866,
    "uuid": "4d2a58b7-450c-49a5-a44f-24dfb457222a",
    "hitokoto": "我希望在20出头的生命里，做一件到八十岁想起来都还会微笑的事。",
    "type": "h",
    "from": "练习曲",
    "from_who": "陈怀恩",
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607266225",
    "length": 31
  },
  {
    "id": 6867,
    "uuid": "2fdc883e-6840-4397-8bc2-3e9a9e9265ba",
    "hitokoto": "我从出生那天起就是我自己，如果你不能理解，那是你的失败，不是我的。",
    "type": "h",
    "from": "大鱼",
    "from_who": "蒂姆·伯顿",
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607266240",
    "length": 33
  },
  {
    "id": 6898,
    "uuid": "ff731097-75ad-4d94-8766-1e911d451708",
    "hitokoto": "我一直在等待你来拯救我的一生，曾经我也感动到一塌糊涂，挥洒热泪，但现实情况是，没有人能拯救一个抑郁症患者，你的医生不能，你的咨询师不能，你的恋人朋友家人更不能。",
    "type": "h",
    "from": "暖暖内含光",
    "from_who": null,
    "creator": "起名废",
    "creator_uid": 7979,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607659684",
    "length": 80
  },
  {
    "id": 7041,
    "uuid": "2e17038a-f398-4917-9c42-1723241cd6fc",
    "hitokoto": "宇宙是蚂蚁的梦。",
    "type": "h",
    "from": "the shivering truth",
    "from_who": null,
    "creator": "卖破烂大户",
    "creator_uid": 8103,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1613444892",
    "length": 8
  },
  {
    "id": 7048,
    "uuid": "b2f7cc0a-dd7a-4ea3-a430-700024284732",
    "hitokoto": "机会的大门没有把手，自己无法打开，当有人替你打开大门时，你能否毫不犹豫地走进去。",
    "type": "h",
    "from": "花牌情缘：结",
    "from_who": "真岛太一",
    "creator": "hito",
    "creator_uid": 8536,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1613666036",
    "length": 40
  },
  {
    "id": 7057,
    "uuid": "63af2ed6-4023-4c49-ae04-8c1e9ae5b00f",
    "hitokoto": "跟你在一起的时光都，很耀眼，因为天气好，因为天气不好，因为天气刚刚好，每一天，都很美好。",
    "type": "h",
    "from": "孤单又灿烂的神：鬼怪",
    "from_who": null,
    "creator": "Mango",
    "creator_uid": 8555,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1613825445",
    "length": 44
  },
  {
    "id": 7121,
    "uuid": "16bee004-1233-4371-a52f-a821a165a279",
    "hitokoto": "时光会把你雕刻成你应有的样子。",
    "type": "h",
    "from": "网剧棋魂",
    "from_who": "时光",
    "creator": "方栩栩",
    "creator_uid": 7486,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1619248045",
    "length": 15
  },
  {
    "id": 7122,
    "uuid": "3d7f06ba-b5c9-4ea5-ab16-80da77d140c7",
    "hitokoto": "比起想念来，千年又何其长。比起相见来，千年又何其短。",
    "type": "h",
    "from": "网剧棋魂",
    "from_who": "褚嬴",
    "creator": "方栩栩",
    "creator_uid": 7486,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1619248161",
    "length": 26
  },
  {
    "id": 7139,
    "uuid": "cdc2bf05-fa47-4503-a25c-a0df9cdbf13e",
    "hitokoto": "Pretty things should be enjoyed.",
    "type": "h",
    "from": "小妇人",
    "from_who": "马奇太太",
    "creator": "小莱",
    "creator_uid": 8580,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1614148460",
    "length": 32
  },
  {
    "id": 7162,
    "uuid": "cd6d4e18-c220-4fe6-b800-f381445851b7",
    "hitokoto": "冬天之所以那么冷是为了告诉大家身边人的温暖有多重要。",
    "type": "h",
    "from": "熔炉",
    "from_who": "孔枝泳",
    "creator": "回望云迷麓",
    "creator_uid": 8629,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1614524862",
    "length": 26
  },
  {
    "id": 7193,
    "uuid": "d1b1020a-654c-4133-8e1e-bbf517ea4223",
    "hitokoto": "为什么我眼睛一睁开，你就不是我的了。",
    "type": "h",
    "from": "被偷走的那五年",
    "from_who": "寂落白",
    "creator": "yudong_820",
    "creator_uid": 8663,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1615031769",
    "length": 18
  },
  {
    "id": 7305,
    "uuid": "b6170b83-7b60-43e5-aeb9-0917a4f2f2ce",
    "hitokoto": "人们宁愿去关心一个蹩脚电影演员的吃喝拉撒和鸡毛蒜皮，而不愿了解一个普通人波涛汹涌的内心世界。",
    "type": "h",
    "from": "平凡的世界",
    "from_who": "路遥",
    "creator": "Hacbox",
    "creator_uid": 8608,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1616906415",
    "length": 46
  },
  {
    "id": 7309,
    "uuid": "14c04652-fc78-4e9f-82b8-f6db87766cb6",
    "hitokoto": "就算是堕落浪子，也能力挽狂澜。",
    "type": "h",
    "from": "网剧棋魂",
    "from_who": "方绪",
    "creator": "方栩栩",
    "creator_uid": 7486,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1619248402",
    "length": 15
  },
  {
    "id": 7310,
    "uuid": "e0bbfce5-f0b7-4cfe-8475-e2978141093b",
    "hitokoto": "如果你执意追逐我的幻影，迟早会被真正的我打败。",
    "type": "h",
    "from": "棋魂",
    "from_who": "时光",
    "creator": "方栩栩",
    "creator_uid": 7486,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1619248191",
    "length": 23
  },
  {
    "id": 7314,
    "uuid": "ea356e81-f212-44a1-8e3c-a70786be040b",
    "hitokoto": "我眺望远方的山峰，却错过转弯的路口，蓦然回首，才发现你在等我，没离开过。",
    "type": "h",
    "from": "没离开过",
    "from_who": "楼南蔚",
    "creator": "赵航锐",
    "creator_uid": 9153,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1619790579",
    "length": 36
  },
  {
    "id": 7315,
    "uuid": "86b88bdf-5c71-46d6-b3b8-7c1b9178169f",
    "hitokoto": "我寻找大海的尽头，却忽略蜿蜒的河流，当我逆水行舟，你在我左右，推着我走。",
    "type": "h",
    "from": "没离开过",
    "from_who": "楼南蔚",
    "creator": "赵航锐",
    "creator_uid": 9153,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1619790629",
    "length": 36
  },
  {
    "id": 7352,
    "uuid": "80272b68-cd62-4441-b358-43045f18b498",
    "hitokoto": "Control is Power.",
    "type": "h",
    "from": "辛德勒的名单",
    "from_who": "奥斯卡·辛德勒",
    "creator": "5N2A",
    "creator_uid": 9466,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1623125876",
    "length": 17
  },
  {
    "id": 7415,
    "uuid": "d1761edd-bfa7-4335-95d7-7bb6e761ee29",
    "hitokoto": "这瓜多少钱一斤？",
    "type": "h",
    "from": "征服",
    "from_who": "刘华强",
    "creator": "jigeshuohua",
    "creator_uid": 10371,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1632695247",
    "length": 8
  },
  {
    "id": 7430,
    "uuid": "4df6834a-b1d6-4f7a-8325-c020debbea05",
    "hitokoto": "你呢，是这辈子没故事，想拥有一段故事，我呢，是故事太多，想给故事一个结局。",
    "type": "h",
    "from": "飞驰认识",
    "from_who": "韩寒",
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1618661843",
    "length": 37
  },
  {
    "id": 7434,
    "uuid": "d6eb2fdb-dade-4ab7-8952-edf50d0f98e6",
    "hitokoto": "每一局棋，都象征着世间万物的运转规律。一招一式，变化无穷，它应该是自由的，我们也是自由的。",
    "type": "h",
    "from": "网剧棋魂",
    "from_who": "褚嬴",
    "creator": "方栩栩",
    "creator_uid": 7486,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1619248253",
    "length": 45
  },
  {
    "id": 7435,
    "uuid": "c4fa0c3c-7335-4ff8-806f-f003ad7d8b09",
    "hitokoto": "有的人，袖里能定乾坤；有的人，春风桃李，俯首为火种；有的人，浪子回头，成为星河里最亮的一颗。",
    "type": "h",
    "from": "网剧棋魂",
    "from_who": "褚嬴",
    "creator": "方栩栩",
    "creator_uid": 7486,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1619248362",
    "length": 46
  },
  {
    "id": 7436,
    "uuid": "fffee04f-0b0f-4738-8e4e-b01cc5293db3",
    "hitokoto": "当你真正想做成一件事情的时候，就连天地万物都会帮你。",
    "type": "h",
    "from": "网剧棋魂",
    "from_who": "褚嬴",
    "creator": "方栩栩",
    "creator_uid": 7486,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1619248686",
    "length": 26
  },
  {
    "id": 7480,
    "uuid": "e41b88f7-8316-4a70-9072-2d03ac00fdc9",
    "hitokoto": "有时候不能指望别人理解你的委屈，感同身受这个东西，这个世界上不存在。",
    "type": "h",
    "from": "我在他乡挺好的",
    "from_who": "南嘉",
    "creator": "慕凯viel",
    "creator_uid": 10019,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1628321412",
    "length": 34
  }
]